import { RSAA } from "redux-api-middleware";
import { getDefaultHeaders, getSettings } from "../Settings";
import dayjs from "dayjs";


export type ActionType = "updateServiceName" |
	"loadTableReservationsStarted" | "loadTableReservationsComplete" | "loadTableReservationsFailed" |
	"loadFreeTablesStarted" | "loadFreeTablesComplete" | "loadFreeTablesFailed" |
	"setArrivedStarted" | "setArrivedComplete" | "setArrivedFailed" |
	"showWalkInDialog" | "hideWalkInDialog" | "clearAvailableTimes" |
	"loadBookingInfoStarted" | "loadBookingInfoComplete" | "loadBookingInfoFailed" | "clearWalkInBooking" |
	"loadAvailableTimesStarted" | "loadAvailableTimesComplete" | "loadAvailableTimesFailed" |
	"bookTableStarted" | "bookTableComplete" | "bookTableFailed";

export const updateServiceName = (serviceName?: string) => ({ type: "updateServiceName", serviceName });

export const showWalkInDialog = () => ({ type: "showWalkInDialog" });
export const hideWalkInDialog = () => ({ type: "hideWalkInDialog" });

export const loadTableReservations = (serviceName: string, overrideDate?: string, forceRefresh: boolean = false) => {
	const meta = { serviceName };

	const params = [] as string[];
	if (overrideDate)
		params.push(`date=${overrideDate}`);
	if (forceRefresh)
		params.push("forcerefresh=true");

	const qs = params.length > 0 ? `?${params.join("&")}` : "";

	return {
		type: "loadTableReservations",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/ombord/reservations/${serviceName}${qs}`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadTableReservationsStarted", meta },
				{ type: "loadTableReservationsComplete", meta },
				{ type: "loadTableReservationsFailed",  meta }
			]
		}
	}
};

export const loadFreeTables = (serviceName: string, overrideDate?: string) => {
	const meta = { serviceName };

	const qs = overrideDate ? `?date=${overrideDate}` : "";

	return {
		type: "loadFreeTables",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/ombord/freetables/${serviceName}${qs}`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadFreeTablesStarted", meta },
				{ type: "loadFreeTablesComplete", meta },
				{ type: "loadFreeTablesFailed",  meta }
			]
		}
	}
};

export const setArrived = (bookingId: number) => {
	const meta = { bookingId };

	return {
		type: "loadTableReservations",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/ombord/reservations/${bookingId}/arrived`,
			headers: getDefaultHeaders(),
			method: "POST",
			types: [
				{ type: "setArrivedStarted", meta },
				{ type: "setArrivedComplete", meta },
				{ type: "setArrivedFailed",  meta }
			]
		}
	}
};

export const loadBookingInfo = (bookingNumber: string) => {
	const meta = { bookingNumber };

	return {
		type: "loadBookingInfo",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/booking/${bookingNumber}/info`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadBookingInfoStarted", meta },
				{ type: "loadBookingInfoComplete", meta },
				{ type: "loadBookingInfoFailed",  meta }
			]
		}
	}
};

export const loadAvailableTimes = (serviceName: string, persons: number, fromTime: dayjs.Dayjs) => {

	const parameters = {
		serviceName,
		persons,
		departureTime: fromTime.format("YYYY-MM-DD HH:mm:ss"),
		arrivalTime: fromTime.endOf("day").format("YYYY-MM-DD HH:mm:ss")
	};

	return {
		type: "loadAvailableTimes" as ActionType,
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/availableTimes`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(parameters),
			types: ["loadAvailableTimesStarted", "loadAvailableTimesComplete", "loadAvailableTimesFailed"]
		}
	} as any;
};

export const bookTable = (serviceName: string, persons: number, date: string, time: string, bookingNumber: string, name?: string) => {
	const parameters = {
		bookingNumber,
		serviceName,
		persons,
		date,
		time,
		name
	};

	return {
		type: "bookTable" as ActionType,
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/tablebooking/ombord/bookWalkIn`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(parameters),
			types: ["bookTableStarted", "bookTableComplete", "bookTableFailed"]
		}
	} as any;
}

export const clearWalkInBooking = () => ({ type: "clearWalkInBooking" });
export const clearAvailableTimes = () => ({ type: "clearAvailableTimes" });